import { useMutation } from "@tanstack/react-query";
import { authApi } from "../api/authApi";

export function useResetPasswordRequestMutation() {
  return useMutation({ mutationFn: authApi.requestPasswordReset });
}
